import { useAsyncProgramPPQContext } from 'contexts/AsyncProgramPPQ/AsyncProgramPPQContext';
import { formatHashId, useMDPModalContext } from 'contexts/MDPModal';
import { usePrePurchaseQuizContext } from 'contexts/PrePurchaseQuiz/PrePurchaseQuizContext';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import { shouldUrlSkipScreenerModal } from 'utils/helpers/urls/skipModal';

type ButtonClickOptions = {
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>;
  ctaUrl: string;
  skipScreenerModal?: boolean;
};

const useMdpModals = () => {
  const {
    hashId,
    isMDPModalAvailable: isScreenerModalAvailable,
    openHandler: openScreenerModal,
  } = useMDPModalContext();

  const { toggleModal: togglePPQModal, isPrePurchaseQuizAvailable } =
    usePrePurchaseQuizContext();
  const hasWCPrePurchaseQuizFeature = useFlags().hasWcPrePurchaseQuiz;
  const {
    toggleModal: toggleAsyncProgramPPQModal,
    isPrePurchaseQuizAvailable: isAsyncProgramQuizAvailable,
  } = useAsyncProgramPPQContext();

  const handleMdpCtaClick = (options: ButtonClickOptions) => {
    const { event, ctaUrl, skipScreenerModal } = options;
    const hash = formatHashId(hashId);

    // This should be a temporary solution until we refactor the quiz to use a dynamic solution
    if (
      isAsyncProgramQuizAvailable &&
      shouldUrlSkipScreenerModal({ url: ctaUrl })
    ) {
      event.preventDefault();
      toggleAsyncProgramPPQModal(true);
      return;
    }

    if (hasWCPrePurchaseQuizFeature && isPrePurchaseQuizAvailable) {
      event.preventDefault();
      togglePPQModal(true);
      return;
    }

    if (isScreenerModalAvailable && !skipScreenerModal) {
      event.preventDefault();
      if (ctaUrl.includes('#') && !ctaUrl.includes(hash)) {
        return;
      }

      openScreenerModal(true);
    }
  };

  return {
    handleMdpCtaClick,
  };
};

export default useMdpModals;
